export function setQueryStringParameter(
  name: string,
  value: string,
  replace = true,
): void {
  if (typeof window === 'undefined') {
    return;
  }

  const params = new URLSearchParams(window.location.search);

  params.set(name, value);

  const newUrl = decodeURIComponent(`${window.location.pathname}?${params}`);

  if (replace) {
    window.history.replaceState({}, '', newUrl);
  } else {
    window.history.pushState({}, '', newUrl);
  }
}
